import { ReturnPolicy, Thumbnail2d } from '@rbx/thumbnails';
import { Item, itemTypeToThumbnailType, urls } from '@modules/miscellaneous/common';
import { useCurrentGame } from '@modules/providers/game/GameProvider';
import {
  Avatar,
  CircularProgress,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
} from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import useLeftNavigationStatusStyles from '@modules/navigation/leftNavigation/componentsV2/LeftNavigationStatus.styles';
import { useStudio } from '@modules/miscellaneous/hooks';
import {
  StatusCardContextMenu,
  CopyTextActionMenuItem,
  OpenLinkActionMenuItem,
  EditInStudioActionMenuItem,
} from '../../common/components';

const {
  getUrlForItemType,
  creatorHub: { dashboard },
} = urls;
const GameStatus = () => {
  const { isLoadingGame, gameDetails, canConfigure } = useCurrentGame();
  const {
    classes: { fullWidth, overflowText, listItemAvatar, avatar },
  } = useLeftNavigationStatusStyles();
  const { open, dialog } = useStudio();
  const { translate } = useTranslation();

  return (
    <List disablePadding classes={{ root: fullWidth }}>
      {dialog}
      {gameDetails !== null ? (
        <ListItem disableGutters>
          <ListItemAvatar className={listItemAvatar}>
            <Avatar variant='rounded' alt='icon' className={avatar}>
              <Thumbnail2d
                targetId={gameDetails.id ?? 0}
                type={itemTypeToThumbnailType[Item.Game]}
                alt={gameDetails.name ?? ''}
                returnPolicy={canConfigure ? ReturnPolicy.AutoGenerated : ReturnPolicy.PlaceHolder}
              />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary={gameDetails.name} classes={{ primary: overflowText }} />
          <ListItemSecondaryAction>
            <StatusCardContextMenu
              menuItems={[
                <CopyTextActionMenuItem
                  actionName={translate('Action.CopyUniverseID')}
                  itemName={translate('Label.UniverseID')}
                  key='copy-universe-id'
                  actionKey='copyUniverseId'
                  textToCopy={gameDetails?.id?.toString()}
                />,
                <CopyTextActionMenuItem
                  actionName={translate('Action.CopyStartPlaceID')}
                  itemName={translate('Label.StartPlaceID')}
                  key='copy-start-place-id'
                  actionKey='copyPlaceId'
                  textToCopy={gameDetails?.rootPlaceId?.toString()}
                />,
                <CopyTextActionMenuItem
                  actionName={translate('Action.CopyURL')}
                  itemName={translate('Label.URL')}
                  key='copy-url'
                  actionKey='copyURL'
                  textToCopy={`${process.env.baseUrl}${dashboard.getExperienceOverviewUrl(gameDetails?.id ?? 0)}`}
                />,
                <OpenLinkActionMenuItem
                  key='view-on-roblox'
                  actionKey='viewOnRoblox'
                  url={getUrlForItemType(Item.Game, gameDetails?.rootPlaceId ?? 0) || ''}
                  actionName={translate('Action.OpenExperienceDetails')}
                />,
                <EditInStudioActionMenuItem
                  key='edit-in-studio'
                  universeId={gameDetails?.id}
                  placeId={gameDetails?.rootPlaceId}
                  openStudio={open}
                />,
              ]}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ) : (
        isLoadingGame && <CircularProgress color='secondary' />
      )}
    </List>
  );
};

export default GameStatus;
